export default {
  COVER_LETTER: {
    name: 'Cover Letter',
    type: 'Cover Letter',
    id: 'COVER_LETTER',
    templateId: 'COVER_LETTER',
  },
};
